import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import CModal from './modal';
export default (props) => {
    return _jsx(_Fragment, { children: _jsx(CModal, { title: props.title || 'Confirm', action: props.action || props.title || 'Confirm', visible: props.visible, onClose: props.onClose, onSubmit: props.onSubmit, level: props.level, children: props.children }) });
};
